import { fetchNHSTagContent } from 'src/pages/tag/actions';
import actionTypes from './actionTypes';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import { removeRecipientFromUrl } from 'src/utils/router';
import modalTypes from 'src/constants/modalTypes';

export function showModal({ modalType = 'DEFAULT', modalProps = {} }) {
  return { type: actionTypes.MODAL_SET, modalType, modalProps };
}

export function setModalProps(modalProps) {
  return { type: actionTypes.MODAL_SET_PROPS, modalProps };
}

export function closeModal() {
  return { type: actionTypes.MODAL_UNSET };
}

export function showSignupModal(signupContext, group, noLoginClose, defaultEmail, onSignupSuccess, redirectPage) {
  return showModal({
    modalType: 'SIGN_UP',
    modalProps: {
      signupContext,
      group,
      noLoginClose,
      defaultEmail,
      onSignupSuccess,
      redirectPage,
    },
  });
}

export function showHuLocalSignupModal(signupContext, defaultEmail, suggestedCommunities) {
  return showModal({
    modalType: 'HULOCAL_SIGN_UP',
    modalProps: {
      signupContext,
      defaultEmail,
      suggestedCommunities,
    },
  });
}

export function showLoginModal({ noClose = false, onLoginSuccess = () => {}, username = undefined } = {}) {
  trackFootfallEvent(footfallEventTypes.CLICKED, { clickType: 'login-modal-viewed' });

  return showModal({
    modalType: 'LOGIN',
    modalProps: {
      noClose,
      onLoginSuccess,
      username,
    },
  });
}

export function showInvalidLoginModal() {
  return showModal({
    modalProps: {
      size: 'sm',
      children: 'Invalid login!',
    },
  });
}

export function showSignupSocialModal(authdata, onSuccess, surveyProps) {
  // Explicit facebook DOB
  if (authdata.birthday) {
    const birthday = authdata.birthday.split('/');
    authdata.dateOfBirth = birthday[2] + '/' + birthday[0] + '/' + birthday[1];
  }
  return showModal({
    modalType: 'SIGN_UP_SOCIAL',
    modalProps: {
      authdata,
      onSuccess,
      surveyProps,
    },
  });
}

export function showExistingLoginSocialModal(authdata, onSuccess) {
  return showModal({
    modalType: 'EXISTING_LOGIN_SOCIAL',
    modalProps: {
      authdata,
      onSuccess,
    },
  });
}

export function showDFPModal(content) {
  return (dispatch, getState) => {
    // BB-1274: Prevent Google Ad Manager (replaces DFP) popups from overwriting our Sign up Modal
    const { modal: { modalType }} = getState();
    if (modalType) return;

    return dispatch(showModal({
      modalType: 'DFP',
      modalProps: { content },
    }));
  };
}

const HIDE_MODAL_CLOSE_BUTTON = '0';
const OPEN_SIGNUP_NORMALLY = '1';
const INACTIVE_USER_SURVEY = '2';
const SURVEY = '3';
const COVID_19_FEATURED_POST_MODAL = '19';
const PROFILE_SURVEY = 'profile';

export const handleQueryParams = (queryParams, footfallSection = '') => {
  return async (dispatch, getState) => {
    if (!queryParams) return;
    // To fix: URLs with hash don't have the params below so opening the welcome back modal doesn't work
    const { utm_source, popup, exit, collector, recipient } = queryParams;
    const recipientParam = recipient;
    const { context: { currentUser, currentCommunity } } = getState();

    if (popup === COVID_19_FEATURED_POST_MODAL) {
      await dispatch(fetchNHSTagContent('coronavirus-covid-19', 'conditions'));
      dispatch(showModal({
        modalType: modalTypes.NHS_TAG_CONTENT,
        modalProps: {
          tagName: 'Coronavirus (COVID-19)',
        },
      }));
      return;
    }

    if (popup === INACTIVE_USER_SURVEY) {
      dispatch(showModal({
        modalType: modalTypes.IFRAME,
        modalProps: {
          iframe: {
            src: `https://www.smartsurvey.co.uk/s/O6STRR/?id=${recipient}`,
            height: '605px',
          },
        },
      }));
      return;
    }

    if (popup === SURVEY) {
      dispatch(showModal({
        modalType: modalTypes.IFRAME,
        modalProps: {
          iframe: {
            src: `https://surveys.healthunlocked.com/s/${collector}/?id=${recipient}`,
            height: '605px',
          },
        },
      }));
      return;
    }

    if (popup === PROFILE_SURVEY) {
      dispatch(showModal({ modalType: modalTypes.PROFILE_SURVEY }));
      return;
    }

    if (currentUser) {
      if (recipientParam) removeRecipientFromUrl();
      return;
    }

    if (utm_source === 'notification') {
      dispatch(showLoginModal({ noClose: true, username: recipientParam }));
      if (recipientParam) {
        // delay removing param to make sure we display username in login modal
        setTimeout(() => removeRecipientFromUrl(), 1500);
      }
    } else if (popup === OPEN_SIGNUP_NORMALLY) {
      const hideClose = exit === HIDE_MODAL_CLOSE_BUTTON;
      trackFootfallEvent(footfallEventTypes.CLICKED, { clickType: 'sign-up', clickMetadata: { section: footfallSection}});
      dispatch(showSignupModal(null, currentCommunity || null, hideClose));
    }
    // TODO: add other modals from BG
  };
};

export function showConfirm(modalProps) {
  return showModal({ modalType: 'CONFIRM', modalProps });
}
